export const SERVICE_FORM_NAME = 'service';


// WEBPACK FOOTER //
// ./src/modules/ServiceForm/constants.js